/**
 * @file 博士会页面
 * @author  rentao(v-rentao@baidu.com)
 */
import React from 'react';
import { Button, Tabs } from 'antd';
import useAssocationHooks from './assocationHooks';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/HeaderWithStore';
import NumberTabGroup from './components/numbertab/numbertabgroup'
import IntersetBannerGroup from './components/interestbanner/intersetbannergroup'

import Word from '../../images/assocation/编组 19.png'
import title1 from '../../images/assocation/标题-简介@2x.png'
import title2 from '../../images/assocation/title2.png'
import title3 from '../../images/assocation/标题-专属权益.png'
import title4 from '../../images/assocation/标题-成员@2x的副本.png'
import interst1 from '../../images/assocation/科研项目支持.png'
import interst2 from '../../images/assocation/前沿议题沙龙.png'
import interst3 from '../../images/assocation/商业生态合作.png'
import interst4 from '../../images/assocation/技术高端人脉.png'
import interst5 from '../../images/assocation/定级峰会VIP.png'
import interst6 from '../../images/assocation/技术专家交流.png'
const Assocation: React.FC = () => {
    const {
        activity,
        memberTabGroup
    } = useAssocationHooks()

    return (
        <div>
            <Header />
            {/* banner图 */}
            <div className="assocation-bgimg">

                <div className="word-box">
                    <img src={Word} alt="" />
                    <a href='https://paddle.wjx.cn/vj/rXbWIr5.aspx'>
                        <Button
                            className="btn"
                            type="primary"
                            size="large"
                        >
                            申请入会
                        </Button>
                    </a>
                </div>
            </div>
            {/* 博士会简介 */}
            <div className="two">
                <div className="intruduce">
                    <img src={title1} alt="" />
                    <div className="intruduce-word1">
                        <p className="word-p1">飞桨博士会是由百度深度学习技术平台飞桨（PaddlePaddle）发起的深度学习技术俱乐部，成员皆为博士及以上学历，且具备深度学习研究和实践经验。飞桨博士会旨在构建人工智能时代下的深度学习核心学者及开发者交流圈，着眼深度学习及交叉学科等科研前沿领域，并推动产业落地实践，致力于用科技让复杂的世界更简单。</p>
                    </div>
                </div>
            </div>
            {/* 博士会近期活动 */}
            <div className="third">
                <div className="third-activity">
                    <img src={title2} alt="" />
                </div>
                <div className="activity">

                    <IntersetBannerGroup  {...activity} />
                </div>
            </div>
            {/* 博士会专属权益 */}
            <div className="four">
                <div className="interest">
                    <img src={title3} alt="" />
                    <div className="in-box">
                        <ul className="in-list">
                            <li className="in-list-li">
                                <img src={interst1} alt="" />
                                <p className="li-p1">技术专家交流</p>
                                <p className="li-p2">百度资深架构师与会员面对面交流</p>
                            </li>
                            <li className="in-list-li">
                                <img src={interst2} alt="" />
                                <p className="li-p1">个人品牌塑造</p>
                                <p className="li-p2">结识更多深度学习技术行业同好</p>
                            </li>
                            <li className="in-list-li">
                                <img src={interst6} alt="" />
                                <p className="li-p1">前沿议题沙龙</p>
                                <p className="li-p2">精选热门前沿科技主题，线下分享现场互动</p>
                            </li>

                        </ul>
                        <ul className="in-list">
                            <li className="in-list-li">
                                <img src={interst5} alt="" />
                                <p className="li-p1">商业生态合作</p>
                                <p className="li-p2">洽谈商业合作，享受企业定制化服务</p>
                            </li>
                            <li className="in-list-li">
                                <img src={interst3} alt="" />
                                <p className="li-p1">科研项目支持</p>
                                <p className="li-p2">松果基金、免费GPU算力等助力科研</p>
                            </li>
                            <li className="in-list-li">
                                <img src={interst4} alt="" />
                                <p className="li-p1">顶级峰会VIP</p>
                                <p className="li-p2">专享WAVE SUMMIT深度学习开发者峰会VIP席位</p>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            {/* 博士会成员 */}
            <div className="five">
                <div className="number">
                    <img src={title4} alt="" />
                    <div className="member-content">
                        <Tabs className="topul" animated>
                            <Tabs.TabPane
                                key="1"
                                tab="最新入驻"
                                id="toplit"
                            >
                                <NumberTabGroup list={memberTabGroup.listSortByTime}/>
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                key="2"
                                tab="A-Z"
                                className="toplib"
                            >
                                <NumberTabGroup list={memberTabGroup.listSortByChar}/>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
            {/* 底部 */}
            <Footer />
        </div>
    )
}

export default Assocation